import React from "react"
import { Button, Grid, Typography } from "@material-ui/core"
import CardSlideshow from "./card-slideshow"
import Bar from "./bar"
import { articles } from "../data/guides"

const routineLinks = [
  {
    title: "Music practice",
    category: "Music",
    image: "blog-violin.png",
    description:
      "Violin, piano, guitar, singing, flute, and cello practice for different levels.",
  },
  {
    title: "Sports training",
    category: "Sports",
    image: "blog-tennis.png",
    description:
      "Soccer, basketball, tennis, swimming, running, and cricket training routines.",
  },
  {
    title: "Study routines",
    category: "Study",
    image: "blog-science.png",
    description:
      "English, maths, science, history, and geography study plans for different school levels.",
  },
]

const GuidePreview = () => (
  <>
    <Grid
      component="section"
      container
      spacing={3}
      style={{ textAlign: "center", padding: "32px 10px 48px" }}
    >
      <Grid item xs={12}>
        <Typography variant="h5" component="h2">
          More ways to make it yours.
        </Typography>
        <Bar />
        <Typography
          variant="subtitle1"
          color="textSecondary"
          style={{ margin: "24px auto", maxWidth: 680 }}
        >
          Keep your weekly routine in view, let AI help with the planning, shift
          activities with a message, and share a calendar your family can
          follow.
        </Typography>
      </Grid>
      <CardSlideshow
        items={articles.filter(article => article.group === "How-to guides")}
        label="More ways to make it yours"
      />
      <Grid item xs={12}>
        <Button
          variant="outlined"
          color="primary"
          size="large"
          href="/guides/?group=How-to%20guides"
        >
          Explore more features
        </Button>
      </Grid>
    </Grid>
    <Grid
      component="section"
      container
      spacing={3}
      style={{ textAlign: "center", padding: "32px 10px 48px" }}
    >
      <Grid item xs={12}>
        <Typography variant="h5" component="h2">
          A little progress, every week.
        </Typography>
        <Bar />
        <Typography
          variant="subtitle1"
          color="textSecondary"
          style={{ margin: "24px auto", maxWidth: 680 }}
        >
          Explore music, sport, and study ideas to find activities that fit your
          interests and give them a place in your week.
        </Typography>
      </Grid>
      <CardSlideshow
        items={[
          ...routineLinks.map(item => ({
            ...item,
            url: `/guides/?group=Activity%20routines&category=${item.category}`,
          })),
          ...articles.filter(article => article.group === "Activity routines"),
        ]}
        label="A little progress, every week"
      />
      <Grid item xs={12}>
        <Button variant="outlined" color="primary" size="large" href="/guides/">
          Explore all guides
        </Button>
      </Grid>
    </Grid>
    <Grid
      component="section"
      container
      spacing={3}
      style={{ textAlign: "center", padding: "32px 10px 48px" }}
    >
      <Grid item xs={12}>
        <Typography variant="h5" component="h2">
          Stand on the shoulders of giants.
        </Typography>
        <Bar />
        <Typography
          variant="subtitle1"
          color="textSecondary"
          style={{ margin: "24px auto", maxWidth: 680 }}
        >
          Put insights from learning research into practice, with study methods,
          worked examples, and weekly plans.
        </Typography>
      </Grid>
      <CardSlideshow
        items={articles.filter(article => article.group === "Study skills")}
        label="Stand on the shoulders of giants"
      />
      <Grid item xs={12}>
        <Button
          href="/study-skills/"
          variant="outlined"
          color="primary"
          size="large"
        >
          Explore study skills
        </Button>
      </Grid>
    </Grid>
  </>
)

export default GuidePreview
